const TextArea: React.FC<React.DetailedHTMLProps<React.TextareaHTMLAttributes<HTMLTextAreaElement>, HTMLTextAreaElement>> = (props) => {
    return (
        <textarea
            {...props}
            className={`
                p-3

                resize-none

              disabled:bg-gray-100 disabled:text-zinc-700'
                
                border outline-none rounded
            `.concat(props.className || '')}
        />
    )
}

export default TextArea